import { BaseWebComponentDataProviderFactory } from '../../../framework/BaseWebComponentDataProviderFactory';
import { CloudWorkloadSecurityCustomerViewDataProvider } from '../dataProvider/CloudWorkloadSecurityCustomerViewDataProvider';
import { API_TYPE_GZ } from '../../../webcomponents.constants';

export class CloudWorkloadSecurityCustomerViewDataProviderFactory extends BaseWebComponentDataProviderFactory {
  constructor() {
    super();
    this.map.set(API_TYPE_GZ, CloudWorkloadSecurityCustomerViewDataProvider);
  }
}
